import React, { useState, useEffect } from "react";
import ImageWithHotspot from "./ImageWithHotspot";
import usePopupImage from "../BowerModal/usePopupImage";

const BathroomImageWithHotspot = (props) => {
  let { images, onHotspotClick } = props;

  return (
    <ImageWithHotspot
      heading="Bathroom"
      subheading="63.8% of household plastic waste"
      onHotspotClick={onHotspotClick}
      images={images}
      imageName="bathroom_03"
      hoverImageName="bathroom_03_hover"
      hotspots={[
        {
          popupImages: usePopupImage(images, "pink", "skincare"),
          x: 23.4,
          y: 19.63,
          tooltipBackground: "",
          averageWaste: "2.28 kg.",
          tooltipTitle: "Title",
          tooltipContent: "",
          popupTableData: {
            "Body Scrub": "0.07 kg.",
            "Body Lotion": "0.08 kg.",
            Cleanser: "0.11 kg.",
            "Cotton Pads": "0.73 kg.",
            Moisturiser: "0.61 kg.",
            "Facial Oil": "0.09 kg.",
            "Facial Scrub": "0.08 kg.",
            "Facial Toner": "0.12 kg.",
            Serum: "0.12 kg.",
            "Face Mask": "0.01 kg.",
            Sunscreen: "0.13 kg.",
            Aftersun: "0.13 kg.",
          },
          popupContent: {
            heading: "Skincare",
            p1: "The UK annual total of plastic waste from skincare products is a whopping 75,805kg. Cotton pads alone account for 32% of this, and moisturising cream accounts for 26%.",
          },
        },
        {
          popupImages: usePopupImage(images, "pink", "bath"),

          x: 62.54,
          y: 23.63,
          tooltipBackground: "",
          tooltipTitle: "Title",
          tooltipContent: "",
          averageWaste: "5.87 kg.",
          popupTableData: {
            "Bath Foam": "0.97 kg.",
            "Shower Gel": "1.85 kg.",
            Shampoo: "1.04 kg.",
            Conditioner: "1.56 kg.",
            "Kids Hair and Body Wash": "0.45 kg.",
          },
          popupContent: {
            heading: "Bath and Shower",
            p1: "We all appreciate lathering up in the shower, but the majority of us won't know that our body wash contributes to 6% of bathroom waste - the worst plastic pollutant in the shower tray! The shampoo and conditioner bottles we accumulate throughout the year amounts to 5% of the whole home's single-use plastic waste - that’s no mean feat for two small bottles!",
          },
        },
        {
          popupImages: usePopupImage(images, "pink", "hygiene"),

          x: 86.95,
          y: 27,
          tooltipBackground: "",
          tooltipTitle: "Title",
          averageWaste: "9.7 kg.",
          tooltipContent: "",
          popupTableData: {
            Deodorant: "2.34 kg.",
            "Hand Lotion": "0.60 kg.",
            "Hand wash": "1.56 kg.",
            Soap: "0.02 kg.",
            "Cotton Buds": "0.26 kg.",
            Tampons: "1.90 kg.",
            "Sanitary Pads": "2.68 kg",
            "Baby and Wet Wipes (packaging)": "0.31 kg.",
          },
          popupContent: {
            heading: "Personal and Feminine Hygiene",
            p1: "Mother earth suffers badly from period pain, as single - use tampons and sanitary pads cumulatively account for 4.6kg of waste per household. Deodorant also has a track record of making environmentalists sweat. Besides the issue of aerosols, deodorants account for 4.8% of annual household plastic waste.",
          },
        },
        {
          popupImages: usePopupImage(images, "pink", "grooming"),
          x: 86.95,
          y: 58.5,
          tooltipBackground: "",
          tooltipTitle: "Title",
          averageWaste: "6.28 kg.",
          tooltipContent: "",
          popupTableData: {
            Hairspray: "0.39 kg.",
            "Hair Oil": "0.57 kg.",
            "Hair Mask": "2.43 kg.",
            "Hair Gel/Wax": "2.43 kg.",
            "Discardable Razors": "0.14 kg.",
            "Razor Blades": "0.24 kg.",
            "Shaving Soap": "0.08 kg.",
          },
          popupContent: {
            heading: "Haircare and Grooming",
            p1: "Unfortunately good hair days for us, lead to bad days for the planet. Who knew treating your locks to a hair mask was such an environmental hazard? Regular use of hair masks and hair gel rack up to 4.9kg of plastic waste a year! In fact, when used regularly, these products are the third worst offenders in the entire bathroom: only sanitary pads and toilet cleaner come out worse.",
          },
        },
        {
          popupImages: usePopupImage(images, "pink", "dental"),

          x: 37.75,
          y: 54.74,
          tooltipBackground: "",
          tooltipContent: "",
          averageWaste: "2.87kg.",
          popupTableData: {
            Floss: "0.08 g",
            Mouthwash: "0.93 kg",
            Toothbrush: "0.24 g",
            "Toothbrush Heads": "0.17 g",
            Toothpaste: "1.46 g",
          },

          popupContent: {
            heading: "Dental Care",
            p1: "Dental care is responsible for 9.3% of all bathroom waste - a large proportion for such a tiny part of the body! Toothpaste accounts for 51% of all dental hygiene waste, with the average Brit going through a shocking 24 tubes a year (brushing 3x a day). Bulky bottles of mouthwash are the biggest offenders, accounting for 2% of your entire home's yearly waste.",
            p2: "In any given Hawaii beach cleanup, it’s not uncommon to pick up to 100 toothbrushes amongst the waste.",
          },
          popupContentExtra: (
            <React.Fragment>
              <h3 className="textLeft">Did you know ...</h3>
              <p className="mx-w-20"></p>
            </React.Fragment>
          ),
        },
        {
          popupImages: usePopupImage(images, "pink", "toilet"),
          x: 31.95,
          y: 72.24,
          tooltipBackground: "",
          averageWaste: "3.96 kg.",
          tooltipTitle: "Title",
          tooltipContent: "",
          popupTableData: {
            "Toilet Cleaner": "3.41 kg.",
            "Toilet Roll": "0.49 kg.",
            "Air Freshener": "0.07 kg.",
          },
          popupContent: {
            heading: "Bathroom Sink Cabinet",
            p1: "Beside being a massive water guzzler, maintaining your loo accounts for a whopping 12.8% of the average bathroom's single-use plastic waste, and 8.2% of the whole household. Alongside deodorant and hair masks, toilet cleaner is one of the bathroom's unassuming, but deadly, single-use plastic offenders.",
            p2: "Around 30% of water used in the home is flushed down the toilet.",
          },
        },
      ]}
    />
  );
};

export default BathroomImageWithHotspot;
